import api from '..';

export const createChineseClothingCompetitionUser = (body, auth, setAuth) => {
  return api.post(`/chinese_clothing_competition_users`, body, auth, setAuth);
};

export const getJoinedSchools = (params, auth, setAuth) => {
  return api.get(`/chinese_clothing_competition_users`, params, auth, setAuth);
};

export const createCompetitionUser = (body, auth, setAuth) => {
  return api.post(`/competition_users`, body, auth, setAuth);
};